import React, { useState } from "react";
import { Row, Col, Form, Button, Nav, Card } from "react-bootstrap";
import Marketingsidebar from "../../../components/Marketing_bar";
import MyClientsModal from "./Client_Modal";
import {
  useMyClientsState,
  businessTypeRoutes,
} from "../../../hooks/useMyClientsState";
import { getAsset } from "../../../helpers/helper";
import ShareModel from "../../../components/Sharemodel";

export const getShopImage = (target) => {
  if (!target) return "";
  const shopObj =
    typeof target === "object"
      ? target.shopid || target.shopId || target.shop || target
      : null;

  let img =
    shopObj?.image ||
    shopObj?.images ||
    shopObj?.imageUrl ||
    shopObj?.shopImage ||
    shopObj?.profileImage ||
    shopObj?.logo ||
    shopObj?.coverImage ||
    target?.image ||
    target?.images ||
    target?.imageUrl;

  if (Array.isArray(img)) {
    img = img.flat(Infinity).find((i) => i && typeof i === "string" && i.trim() !== "") || img[0];
  }
  if (img && typeof img === "object") {
    img = img.url || img.image || img.imageUrl || img.path || img.src;
  }
  if (!img || typeof img !== "string" || !img.trim()) return "";
  const assetUrl = getAsset(img);
  return assetUrl && !assetUrl.endsWith("/assets/") && !assetUrl.endsWith("/assets/images/") ? assetUrl : "";
};

const MyClients = () => {
  const {
    activeClientTab,
    setActiveClientTab,
    activePlanTab,
    setActivePlanTab,
    searchQuery,
    setSearchQuery,
    show,
    setShow,
    isOpen,
    setIsOpen,
    isLoading,
    filteredClients,
    handleStartWork,
    handleBeginWork,
    handleViewStatistics,
  } = useMyClientsState();

  const [showShareModal, setShowShareModal] = useState(false);
  const [selectedShopId, setSelectedShopId] = useState(null);
  const [selectedShareUrl, setSelectedShareUrl] = useState("");
  const [selectedShopTitle, setSelectedShopTitle] = useState("");
  const [selectedShopDesc, setSelectedShopDesc] = useState("");
  const [selectedShopImage, setSelectedShopImage] = useState("");

  return (
    <Row>
      <div className="screenHeight marketing-height-manage p-3">
        <MyClientsModal show={show} onHide={() => setShow(false)} />
        <ShareModel
          show={showShareModal}
          handleClosemodal={() => setShowShareModal(false)}
          handleShowshare={() => {}}
          shareurl={selectedShareUrl}
          shopid={selectedShopId}
          shopTitle={selectedShopTitle}
          shopDesc={selectedShopDesc}
          shopImage={selectedShopImage}
        />

        {/* Left Sidebar */}
        <Col
          lg="3"
          xl="3"
          sm="12"
          xs="12"
          className="bg-white shadow-sm marketing-sidebar-height sidebar-border rounded"
        >
          <Marketingsidebar isOpen={isOpen} setIsOpen={setIsOpen} />
        </Col>

        {/* Right Section */}
        <Col
          lg={8}
          md={12}
          sm={12}
          className="p-5 shadow rounded"
          style={{ backgroundColor: "#f8fbff" }}
        >
          {/* Title */}
          <h2
            className="mb-4"
            style={{
              color: "#0353a4",
              fontWeight: "bold",
              fontSize: "1.8rem",
            }}
          >
            My Clients
          </h2>

          {/* Client Status Tabs */}
          <div className="mb-4">
            <Nav className="border-0">
              {[
                { key: "active", label: "Active Clients" },
                { key: "completed", label: "Successfully Completed" },
                { key: "inactive", label: "Inactive Clients" },
              ].map((tab) => (
                <Nav.Item key={tab.key}>
                  <Nav.Link
                    active={activeClientTab === tab.key}
                    onClick={() => setActiveClientTab(tab.key)}
                    className="px-3 py-2"
                    style={{
                      color:
                        activeClientTab === tab.key ? "#0353a4" : "#6c757d",
                      fontWeight:
                        activeClientTab === tab.key ? "bold" : "normal",
                      borderBottom:
                        activeClientTab === tab.key
                          ? "3px solid #0353a4"
                          : "3px solid transparent",
                      borderRadius: 0,
                      marginBottom: "-1px",
                      fontSize: "0.95rem",
                    }}
                  >
                    {tab.label}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
            <hr />
          </div>

          {/* Plan Tabs */}
          <div className="mb-4 d-flex flex-wrap gap-2">
            {[
              { key: "all", label: "All Plans" },
              { key: "basic", label: "Basic" },
              { key: "standard", label: "Standard" },
              { key: "premium", label: "Premium" },
            ].map((tab) => (
              <Button
                key={tab.key}
                size="sm"
                onClick={() => setActivePlanTab(tab.key)}
                style={{
                  borderRadius: "20px",
                  fontSize: "0.8rem",
                  fontWeight: "500",
                  padding: "0.3rem 0.9rem",
                  border: "1px solid #0353a4",
                  backgroundColor:
                    activePlanTab === tab.key ? "#0353a4" : "transparent",
                  color: activePlanTab === tab.key ? "#fff" : "#0353a4",
                }}
              >
                {tab.label}
              </Button>
            ))}
          </div>

          {/* Search + Add Button */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4 gap-3">
            <Form.Control
              type="text"
              placeholder="Search by Shop Name, City, Plan Type"
              className="border rounded"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{
                maxWidth: "400px",
                width: "100%",
                height: "40px",
                fontSize: "0.9rem",
                paddingLeft: "2.5rem",
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%236c757d' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'/%3E%3C/svg%3E")`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "0.75rem center",
              }}
            />

            <Button
              variant="primary"
              style={{
                backgroundColor: "#0353a4",
                border: "none",
                borderRadius: "6px",
                padding: "0.5rem 1rem",
                fontSize: "0.9rem",
                fontWeight: "500",
              }}
              onClick={() => setShow(true)}
            >
              Add/connect new Client
            </Button>
          </div>

          {/* Client Cards */}
          <Row className="g-4">
            {isLoading ? (
              <Col className="d-flex justify-content-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </Col>
            ) : filteredClients.length === 0 ? (
              <Col>
                <p className="text-center text-muted">No clients found.</p>
              </Col>
            ) : (
              filteredClients.map((client) => {
                const rawShop = client.shopid || client.shopId || client.shop;
                const shopObj = rawShop && typeof rawShop === "object" ? rawShop : null;
                const shopName =
                  shopObj?.shopname ||
                  shopObj?.companyname ||
                  shopObj?.profileName ||
                  shopObj?.title ||
                  shopObj?.name ||
                  shopObj?.shopName ||
                  (typeof rawShop === "string" ? rawShop : "Client Shop");
                const clientName =
                  client.userid?.fullname ||
                  client.userId?.fullname ||
                  (typeof client.userid === "string" ? client.userid : "N/A");
                const shopImgUrl = getShopImage(client);

                return (
                  <Col key={client._id} md={6} lg={4} xl={3}>
                    <Card
                      className="h-100 border-0 shadow-sm position-relative"
                      style={{ borderRadius: "12px", overflow: "hidden" }}
                    >
                      {/* Badge */}
                      <div
                        className="position-absolute top-0 start-0 m-2 text-white"
                        style={{
                          backgroundColor:
                            client.taskStatus === "completed"
                              ? "#0353a4"
                              : client.taskStatus === "inProgress"
                              ? "#198754"
                              : client.paymentStatus === "success"
                              ? "#fd7e14"
                              : "#dc3545",
                          padding: "0.2rem 0.5rem",
                          borderRadius: "4px",
                          fontSize: "0.7rem",
                          fontWeight: "bold",
                          zIndex: 10,
                        }}
                      >
                        {client.taskStatus === "completed"
                          ? "COMPLETED"
                          : client.taskStatus === "inProgress"
                          ? "IN PROGRESS"
                          : client.paymentStatus === "success" &&
                            client.taskStatus === "pending"
                          ? "AWAITING START"
                          : (client.paymentStatus || "").toUpperCase()}
                      </div>

                      {/* Share Button */}
                      <div
                        className="position-absolute top-0 end-0 m-2 text-white d-flex align-items-center gap-1"
                        style={{
                          backgroundColor: "#0353a4",
                          padding: "0.2rem 0.5rem",
                          borderRadius: "4px",
                          fontSize: "0.7rem",
                          cursor: "pointer",
                          zIndex: 10,
                        }}
                        onClick={() => {
                          const viewId =
                            shopObj?._id ||
                            (typeof rawShop === "string" ? rawShop : null) ||
                            client._id;
                          const businessType =
                            shopObj?.businessType ||
                            shopObj?._profileType ||
                            client.businessType;
                          const route =
                            businessTypeRoutes[businessType] ||
                            "/NewItem-bussines-Profile/";
                          const sUrl = viewId ? `${route}${viewId}` : "";

                          setSelectedShopId(viewId);
                          setSelectedShareUrl(sUrl);
                          setSelectedShopTitle(shopName);
                          setSelectedShopDesc(shopObj?.description || "");
                          setSelectedShopImage(shopImgUrl);
                          setShowShareModal(true);
                        }}
                      >
                        <i className="bi bi-share"></i>
                        <span className="d-none d-md-inline">Share</span>
                      </div>

                      {/* Shop Image */}
                      <div
                        style={{
                          height: "140px",
                          backgroundColor: "#f0f0f0",
                          overflow: "hidden",
                          position: "relative",
                        }}
                      >
                        {shopImgUrl ? (
                          <img
                            src={shopImgUrl}
                            alt={shopName}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                            onError={(e) => {
                              e.target.style.display = "none";
                            }}
                          />
                        ) : (
                          <div
                            className="w-100 h-100 d-flex align-items-center justify-content-center text-muted"
                            style={{ fontSize: "0.8rem" }}
                          >
                            No Image
                          </div>
                        )}
                      </div>

                      <Card.Body className="p-3">
                        <div className="d-flex justify-content-between align-items-start mb-1">
                          <h6
                            className="mb-0"
                            style={{ fontSize: "0.95rem", fontWeight: "600" }}
                          >
                            {shopName}
                          </h6>
                        </div>

                        <p
                          className="mb-1"
                          style={{ fontSize: "0.9rem", fontWeight: "500" }}
                        >
                          Plan: {client.planId?.planName || "N/A"}
                        </p>

                        <p
                          className="mb-1"
                          style={{ fontSize: "0.8rem", color: "#6c757d" }}
                        >
                          Client: {clientName}
                        </p>

                        <div className="d-flex gap-2">
                          {client.paymentStatus === "success" &&
                            client.taskStatus === "pending" && (
                              <button
                                size="sm"
                                className="flex-grow-1 text-white btn pt-0 pb-0 ps-3 pe-3"
                                style={{
                                  backgroundColor: "#198754",
                                  border: "none",
                                  fontSize: "0.8rem",
                                  borderRadius: "20px",
                                }}
                                onClick={() => handleBeginWork(client)}
                              >
                                Start Work
                              </button>
                            )}

                          {client.paymentStatus === "success" &&
                            client.taskStatus === "inProgress" && (
                              <button
                                size="sm"
                                className="flex-grow-1 text-white btn pt-0 pb-0 ps-3 pe-3"
                                style={{
                                  backgroundColor: "#0353a4",
                                  border: "none",
                                  fontSize: "0.8rem",
                                  borderRadius: "20px",
                                }}
                                onClick={() => handleStartWork(client)}
                              >
                                View Shop
                              </button>
                            )}

                          <button
                            size="sm"
                            className="flex-grow-1 btn border pt-0 pb-0 ps-3 pe-3"
                            style={{
                              fontSize: "0.8rem",
                              borderRadius: "20px",
                              color: "#6c757d",
                              borderColor: "#ced4da",
                            }}
                            onClick={() => handleViewStatistics(client)}
                          >
                            Statics
                          </button>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })
            )}
          </Row>
        </Col>
      </div>
    </Row>
  );
};

export default MyClients;
